import "./Connect.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DirectConnect from "./sections/DirectConnect";
import ExpertConsultationFaq from "./sections/ExpertConsultationFaq";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <MainNavigation />
      <DirectConnect />
      <ExpertConsultationFaq />
      <Footer />
    </div>;
}